import { FC, useEffect, useRef, useState } from "react";
import ObjectDetailsSection from "components/sections/objects/ObjectDetailsSection/ObjectDetailsSection";
import ObjectTabsLayout from "components/common/objects/ObjectTabsLayout/ObjectTabsLayout";

// Data
import { useAppDispatch, useAppSelector } from "hooks";
import {
  selectActiveObjectAlarmsConfig,
  selectDrawerSelectedAccountId,
  selectSpecificObjectState
} from "app/data/selectors";
import { useNavigate } from "react-router-dom";
import { getSubscriptionsAction } from "domain/subscriptions/store/actions/get-subscriptions.action";
import { SubscriptionsRequestDto } from "domain/subscriptions/entities/dtos/subscriptions-request.dto";

const ObjectDetails: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Global State
  const drawerSelectedAccountId =
    useAppSelector(selectDrawerSelectedAccountId) || "";
  const { specificObject } = useAppSelector(selectSpecificObjectState);
  const { alarmsConfig } = useAppSelector(selectActiveObjectAlarmsConfig);
  const [selectAccountId, setSelectedAccountId] = useState(
    drawerSelectedAccountId
  );
  const prevAccountIdRef = useRef<string>();
  const prevObjectIdRef = useRef<string>();

  useEffect(() => {
    if (drawerSelectedAccountId !== selectAccountId) {
      setSelectedAccountId(drawerSelectedAccountId);
      navigate("/dashboard/objects");
    }
  }, [drawerSelectedAccountId]);

  useEffect(() => {
    const currentObjectId = specificObject?.uniqueId;
    const accountChanged = prevAccountIdRef.current !== drawerSelectedAccountId;
    const objectChanged = prevObjectIdRef.current !== currentObjectId;

    if (
      drawerSelectedAccountId &&
      currentObjectId &&
      (accountChanged || objectChanged)
    ) {
      const requestPayload: SubscriptionsRequestDto = {
        accountId: drawerSelectedAccountId,
        objectId: currentObjectId
      };
      dispatch(getSubscriptionsAction(requestPayload));
    }

    prevAccountIdRef.current = drawerSelectedAccountId;
    prevObjectIdRef.current = currentObjectId;
  }, [drawerSelectedAccountId, specificObject]);

  return (
    <main>
      <ObjectTabsLayout>
        <ObjectDetailsSection
          specificObject={specificObject}
          alarmsConfig={alarmsConfig}
        />
      </ObjectTabsLayout>
    </main>
  );
};

export default ObjectDetails;
